import React from 'react'

function Methods() {
    return (
        <div className=" bg-white flex flex-col items-center justify-center text-white p-8">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
                <div className="bg-gray-800 p-6 rounded-lg">
                    <h2 className="text-2xl font-semibold">Email Us</h2>
                    <p className="mt-2">contact@worldwideevidence</p>
                </div>
                <div className="bg-gray-800 p-6 rounded-lg">
                    <h2 className="text-2xl font-semibold">Text Us</h2>
                    <p className="mt-2">(725) 577-4524</p>
                </div>
                <div className="bg-gray-800 p-6 rounded-lg">
                    <h2 className="text-2xl font-semibold">Voice assistant</h2>
                    <p className="mt-2">(725) 712-4726</p>
                </div>
            </div>
        </div>
    )
}

export default Methods
